(() => {
  const OLD_TITLE = 'Commande avant 10 h';
  const OLD_TEXT = '= expédition le jour même';
  const NEW_TITLE = 'Paiement à 30 jours';
  const NEW_TEXT = 'après validation du dossier';

  function updatePaymentTrustBlock() {
    document.querySelectorAll('strong, h3, h4').forEach((title) => {
      if (title.textContent.trim() !== OLD_TITLE) return;

      const container = title.closest('.bd-trust-block__item, [class*="trust"][class*="item"], article, li, div');
      title.textContent = NEW_TITLE;

      if (!container) return;

      const subtitle = Array.from(container.querySelectorAll('span, p')).find(
        (element) => element.textContent.trim() === OLD_TEXT
      );
      if (subtitle) subtitle.textContent = NEW_TEXT;

      const icon = Array.from(container.querySelectorAll('span, div')).find(
        (element) => element.textContent.trim() === '⚡'
      );
      if (icon) icon.textContent = '📅';
    });
  }

  function start() {
    updatePaymentTrustBlock();
    const observer = new MutationObserver(updatePaymentTrustBlock);
    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', updatePaymentTrustBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
